export const religionCastes = {
    HINDU: {
        value: "hindu",
        castes: [
            {value: "ezhava", name: "EZHAVA"},
            {value: "nair", name: "NAIR"},
            {value: "thiyya", name: "THIYYA"},
            {value: "pulaya", name: "PULAYA"},
            {value: "pandara", name: "PANDARA"},
            {value: "pillai", name: "PILLAI"},
            {value: "velan", name: "VELAN"},
            {value: "valan", name: "VALAN"},
            {value: "vishwakarma", name: "VISHWAKARMA"},
            {value: "brahmin_namboothiri", name: "NAMBOOTHIRI BRAHMIN"},
            {value: "brahmin_tamil", name: "TAMIL BRAHMIN"},
            {value: "brahmin_konkani", name: "KONKANI BRAHMIN"},
            {value: "ambalavasi", name: "AMBALAVASI"}, // temple service castes
            {value: "veluthedathu", name: "VELUTHEDATHU"},
            {value: "vellalar", name: "VELLALAR"},
            {value: "chakkala", name: "CHAKKALA (OIL PRESSER)"},
            {value: "karuvan", name: "KARUVAN"},
            {value: "paraya", name: "PARAYA"},
            {value: "cheramar", name: "CHERAMAR"},
            {value: "kurava", name: "KURAVA"},
            {value: "vettuvan", name: "VETTUVAN"},
            {value: "mannan", name: "MANNAN"},
            {value: "arayan", name: "ARAYAN (FISHERMEN)"},
            {value: "mukkuva", name: "MUKKUVA"},
            {value: "vellalas", name: "VELLALAS (Tamil migrants)"},
            {value: "thandan", name: "THANDAN"},
            {value: "kavara", name: "KAVARA"},
            {value: "maran", name: "MARAN"},
            {value: "illathu_pillai", name: "ILLATHU PILLAI"},
            {value: "adi_dravidar", name: "ADI DRAVIDAR"},
        ],
    },
    MUSLIM: {
        value: "muslim",
        castes: [
            {value: "sunni", name: "SUNNI"},
            {value: "shia", name: "SHIA"},
            {value: "pathan", name: "PATHAN"},
            {value: "syed", name: "SYED"},
            {value: "memon", name: "MEMON"},
            {value: "bohra", name: "BOHRA"},
            {value: "ahmadiyya", name: "AHMADIYYA"},
            {value: "mappila", name: "MAPPILA"},
            {value: "sheikh", name: "SHEIKH"},
            {value: "ansari", name: "ANSARI"},
            {value: "qureshi", name: "QURESHI"},
            {value: "mughal", name: "MUGHAL"},
            {value: "khan", name: "KHAN"},
            {value: "malik", name: "MALIK"},
            {value: "chisti", name: "CHISTI"},
            {value: "naqvi", name: "NAQVI"},
            {value: "abbasi", name: "ABBASI"},
            {value: "farooqui", name: "FAROOQUI"},
            {value: "usmani", name: "USMANI"},
            {value: "siddiqui", name: "SIDDIQUI"},
        ],
    },
    CHRISTIAN: {
        value: "christian",
        castes: [
            {value: "roman_catholic", name: "ROMAN CATHOLIC"},
            {value: "protestant", name: "PROTESTANT"},
            {value: "orthodox", name: "ORTHODOX"},
            {value: "pentecostal", name: "PENTECOSTAL"},
            {value: "syrian_christian", name: "SYRIAN CHRISTIAN"},
            {value: "jacobite", name: "JACOBITE"},
            {value: "mar_thoma", name: "MAR THOMA"},

            // 🔹 Kerala-specific
            {value: "latin_catholic", name: "LATIN CATHOLIC"},
            {value: "knanaya_catholic", name: "KNANAYA CATHOLIC"},
            {value: "knanaya_jacobite", name: "KNANAYA JACOBITE"},
            {value: "syro_malabar", name: "SYRO-MALABAR CATHOLIC"},
            {value: "syro_malankara", name: "SYRO-MALANKARA CATHOLIC"},
            {value: "chaldean_syrian", name: "CHALDEAN SYRIAN"},
            {value: "st_thomas_christian", name: "ST. THOMAS CHRISTIAN"},

            // 🔹 Goa / West India
            {value: "goan_catholic", name: "GOAN CATHOLIC"},
            {value: "mangalorean_catholic", name: "MANGALOREAN CATHOLIC"},
            {value: "anglo_indian", name: "ANGLO INDIAN"},

            // 🔹 North-East India
            {value: "naga_christian", name: "NAGA CHRISTIAN"},
            {value: "mizo_christian", name: "MIZO CHRISTIAN"},
            {value: "khasi_christian", name: "KHASI CHRISTIAN"},
            {value: "garo_christian", name: "GARO CHRISTIAN"},

            // 🔹 Other denominations
            {value: "baptist", name: "BAPTIST"},
            {value: "lutheran", name: "LUTHERAN"},
            {value: "methodist", name: "METHODIST"},
            {value: "presbyterian", name: "PRESBYTERIAN"},
            {value: "adventist", name: "SEVENTH-DAY ADVENTIST"},
            {value: "jehovah_witness", name: "JEHOVAH'S WITNESS"},
        ],
    },
    SIKH: {
        value: "sikh",
        castes: [
            {value: "jatt", name: "JATT"},
            {value: "ramgarhia", name: "RAMGARHIA"},
            {value: "khatri", name: "KHATRI"},
            {value: "majhabi", name: "MAJHABI"},
            {value: "saini", name: "SAINI"},
            {value: "arora", name: "ARORA"},
        ],
    },
    BUDDHIST: {
        value: "buddhist",
        castes: [
            {value: "mahayana", name: "MAHAYANA"},
            {value: "theravada", name: "THERAVADA"},
            {value: "vajrayana", name: "VAJRAYANA"},
            {value: "zen", name: "ZEN"},
            {value: "pure_land", name: "PURE LAND"},
            {value: "navayana", name: "NAVAYANA"}, // Ambedkarite Buddhism in India
        ],
    },
    JAIN: {
        value: "jain",
        castes: [
            {value: "digambar", name: "DIGAMBAR"},
            {value: "svetambar", name: "SVETAMBAR"},
            {value: "terapanthi", name: "TERAPANTHI"},
            {value: "sthanakvasi", name: "STHANAKVASI"},
            {value: "murti_pujak", name: "MURTI PUJAK"},
        ],
    },
    PARSI: {
        value: "parsi",
        castes: [
            {value: "irani", name: "IRANI"},
            {value: "parsi_zoroastrian", name: "PARSI ZOROASTRIAN"},
        ],
    },
    JEWISH: {
        value: "jewish",
        castes: [
            {value: "cochin_jews", name: "COCHIN JEWS"},
            {value: "bene_israel", name: "BENE ISRAEL"},
            {value: "baghdadi_jews", name: "BAGHDADI JEWS"},
        ],
    },
    TRIBAL: {
        value: "tribal",
        castes: [
            {value: "gond", name: "GOND"},
            {value: "santhal", name: "SANTHAL"},
            {value: "oraon", name: "ORAON"},
            {value: "munda", name: "MUNDA"},
            {value: "khasi", name: "KHASI"},
            {value: "naga", name: "NAGA"},
        ],
    },
};
